const JiraProjectId = {
  join: (cloudId, projectKey) => `${cloudId}:${projectKey}`,
  split: (id) => {
    const firstColonIdx = id.indexOf(':')
    const cloudId = id.slice(0, firstColonIdx)
    const projectKey = id.slice(firstColonIdx + 1)
    return {cloudId, projectKey}
  }
}

export default JiraProjectId
